module.exports = __webpack_public_path__ + "img/togo.64edaffb.svg";